// removed by extract-text-webpack-plugin
module.exports = {"controls":"upgrade-downgrade-modal__controls___2fE0l"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/upgrade-downgrade-modal.scss
// module id = 1365
// module chunks = 0